module.exports = "<div>\n  <a [routerLink]=\"['object-fields']\">Fält</a>\n  <a [routerLink]=\"['object-field-templates']\">Fält-mallar</a>\n</div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings/settings.component.html
// module id = ./src/app/settings/settings/settings.component.html
// module chunks = main